import { useEffect } from 'react';

import type { ProductKeys } from '../../../../constants/products';

type ResetProductsWithTimeoutProps = {
	setProductsWithTimeout: React.Dispatch<React.SetStateAction<ProductKeys[] | undefined>>;
};

export const ResetProductsWithTimeout = ({
	setProductsWithTimeout,
}: ResetProductsWithTimeoutProps) => {
	useEffect(() => {
		setProductsWithTimeout(undefined);
	}, [setProductsWithTimeout]);

	return null;
};
